import { render, staticRenderFns } from "./publishedTasks.vue?vue&type=template&id=4a703870&scoped=true&"
import script from "./publishedTasks.vue?vue&type=script&lang=js&"
export * from "./publishedTasks.vue?vue&type=script&lang=js&"
import style0 from "./publishedTasks.vue?vue&type=style&index=0&id=4a703870&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a703870",
  null
  
)

export default component.exports